// extracted by mini-css-extract-plugin
module.exports = {"root":"ProfileStatusBanner_root__urM2B","text":"ProfileStatusBanner_text__1prKm","button":"ProfileStatusBanner_button__1cCxq"};